import React, { Component } from "react";
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonLabel, IonSpinner } from "@ionic/react";

import "../Shared.css";
import "../../App.css";
import "./MessageBar.css";

import { IScreenProps, IUser } from "../Interfaces";
import { Collapse } from "react-collapse";

import iconTick from "../assets/Button_Tick_15x15@3x.png";

type Props = {
  messageBarText: IScreenProps["messageBarText"];
};
type State = {};

class MessageBar extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    return (
      <>
        {this.props.messageBarText !== "" ? (
          <div
            className={`updateMessageContainer ${
              this.props.messageBarText === "You're up to date" ? "updateMessageContainerFinished" : ""
            }`}
          >
            {this.props.messageBarText === "You're up to date" ? (
              <img alt="" className="updateMessageTick" src={iconTick} />
            ) : null}
            {this.props.messageBarText}
          </div>
        ) : null}
      </>
    );
  }
}

export default MessageBar;
